'use client'

import React, { createContext, ReactNode } from 'react'

import { EventItem } from 'Types/emajinAPI'

type RSVPContextType = {
  event?: EventItem
  onOpenEvents: () => void
}

const RSVPContext = createContext<RSVPContextType | null>(null)

export const RSVPProvider = ({
  values,
  children,
}: {
  values: RSVPContextType
  children: ReactNode
}) => <RSVPContext.Provider value={values}>{children}</RSVPContext.Provider>
